<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">

        <path class="st0 svg-secondary-color" d="M21.5,13v-3l-4,4l4,4v-3h3v-2H21.5z M6.5,13h-3v2h3v3l4-4l-4-4V13z M14.5,22h2V6h-2V22z M11.5,22h2V6h-2V22z"/>
        <path class="st1 svg-outline-color" d="M24,28H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h20c2.2,0,4,1.8,4,4v20C28,26.2,26.2,28,24,28z M4,1
	C2.3,1,1,2.3,1,4v20c0,1.7,1.3,3,3,3h20c1.7,0,3-1.3,3-3V4c0-1.7-1.3-3-3-3H4z"/>

    </svg>

</template>

<script>
import {mapGetters} from 'vuex';

export default {
        name: "IconCollapseColumn",
        computed: {
            ...mapGetters({
                // getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/IconCollapseColumn.vue